<template>
  <div class="publicBuy">
    <div class="safe">
      <div class="buyBox">
        <div class="title">
          兑换联合会员
        </div>
        <div class="card card1">
          <div class="cardName">
            中国体育超级会员·{{cardValue}}
          </div>
          <div class="cardBox">
            <div class="logo">
              <img :src="userInfo.userHeadImg" alt="">
            </div>
            <div class="countInfo">
              <div class="word">
                兑换账号
              </div>
              <div class="count">
                {{userInfo.userName}}
              </div>
            </div>
          </div>
        </div>
        <div class="card card2">
          <div class="cardName">
            央视体育VIP·{{cardValue}}  
          </div>
          <div class="cardBox">
            <div class="logo">
              <img src="https://images.zhibo.tv/2021/0601/cctv_logo.png" alt="">
            </div>
            <div class="countInfo">
              <div class="word">
                兑换账号
              </div>
              <div class="count">
                {{conductMobile(userInfo.userMobile)}}
              </div>
            </div>
          </div>
        </div>
        <div class="exchangeDesc">
          请确认账户信息无误，兑换成功后不支持更换账号
        </div>
        <div class="btn" @click="handleBtn">
          确认兑换
        </div>
        <!-- 关闭按钮 -->
        <div class="icon_close" @click="doClose">
          <img src="https://images.zhibo.tv/2021/0509/icon_cancel@3x.png" alt="">
        </div>
        <!-- <publicpay :payinfo="payinfo" @changePayDialogShow='showPayDialog' v-show="payDialogIsShow" :payDialogIsShow='payDialogIsShow'></publicpay> -->
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['carmiValue', 'code', 'userInfo', 'token'],
  name: '',
  data () {
    return {
      // 支付弹窗
      payDialogIsShow: false,
      cardValue: ''
    };
  },
  computed: {
  },
  created () {
    console.log(this.code, 'this.code')
    this.cardValue = this.code[2] === 'M' ? '月卡' : '年卡'
  },
  methods: {
    // 点击确认(购买/兑换)
    async handleBtn () {
      let params = {
        card_id: this.code,
        code: this.carmiValue,
        phone: this.userInfo.userMobile,
        source: '1',
        clinet_type: this.$CONFIG.isIOS ? '3' : '2'
      }
      const { data } = await this.$vipapi.exchangeVip(params)
      console.log(data, 'data', data.data)
      if (data.data.code === 0) {
        this.$emit('showDialog', 'succes', data.data.vip_info );
      } else {
        this.$emit('changeToast', data.data.message)
      }
    },
    // 控制是否展示支付弹窗
    showPayDialog (visible) {
      this.payDialogIsShow = visible
    },
    // 关闭
    doClose () {
      // 触发父组件中的dialogVisibleEvent事件，并传递参数
      this.$emit('showDialog', false);
    },
    // 处理手机格式
    conductMobile(val) {
      let reg = /1(\d{2})\d{4}(\d{4})/g;
      return val && val.length > 0 ? val.replace(reg, "1$1****$2") : val
    }
  }
}
</script>

<style lang='less' scoped>
.publicBuy {
  // display: none;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  // padding-bottom: constant(safe-area-inset-bottom); //兼容IOS < 11.2
  // padding-bottom: env(safe-area-inset-bottom); //兼容IOS > 11.2
  .safe {
    position: absolute;
    left: 0;
    bottom: 0;
    background: #ffffff;
    // margin-bottom: 84px !important;
    padding-bottom: constant(safe-area-inset-bottom); //兼容IOS < 11.2
    padding-bottom: env(safe-area-inset-bottom); //兼容IOS > 11.2
  }

  .buyBox {
    // margin-bottom: 1rem;
    width: 7.5rem;
    padding: 0.4rem 0.32rem 0.16rem 0.32rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.24rem 0.24rem 0 0;

    display: flex;
    align-items: center;
    flex-direction: column;

    .title {
      margin-bottom: 0.3rem;
      font-size: 0.34rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 0.48rem;
    }
    .price {
      margin-top: 0.08rem;
      margin-bottom: 0.04rem;
      font-size: 0.88rem;
      font-family: BebasNeue;
      color: #222222;
      line-height: 1.24rem;
    }
    .card {
      // margin-top: 0.3rem;
      margin-bottom: 0.4rem;
      .cardName {
        margin-left: 0.04rem;
        margin-bottom: 0.12rem;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 0.4rem;
      }
      .cardBox {
        display: flex;
        justify-content: space-between;
        width: 6.86rem;
        height: 1.24rem;
        background: #f7f7f7;
        border-radius: 0.2rem;
        box-sizing: border-box;
        padding: 0.12rem 0.2rem 0.12rem 0.12rem;
        .logo {
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          justify-content: center;
          align-items: center;
          display: flex;
          img {
            width: 1rem;
            height: 1rem;
            border-radius: 50%;
            display: block;
            object-fit: contain;
          }
        }
        .countInfo {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: space-between;
          margin: 0.11rem 0 0.13rem 0;
          .word {
            font-size: 0.24rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 0.32rem;
          }
          .count {
            font-size: 0.24rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 0.32rem;
          }
        }
      }
    }
    .card1 {
      margin-top: 0.3rem;
    }
    .card2 .logo {
      background: #3a3a3c;
      img {
        width: .66rem!important;
      }
    }
    .btn {
      width: 6.9rem;
      height: 0.88rem;
      margin-top: 0.44rem;
      margin-bottom: 0.2rem;
      background: url('https://images.zhibo.tv/2021/0509/btns@2x.png') no-repeat center;
      background-size: 100%;
      text-align: center;
      font-size: 0.32rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #984b26;
      line-height: 0.88rem;
    }
    .exchangeDesc {
      font-size: 0.2rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 0.28rem;
      padding-bottom: constant(safe-area-inset-bottom); //兼容IOS < 11.2
      padding-bottom: env(safe-area-inset-bottom); //兼容IOS > 11.2
    }
    .icon_close {
      position: absolute;
      width: 0.32rem;
      height: 0.32rem;
      right: 0.32rem;
      top: 0.32rem;
      img {
        display: block;
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
}
@supports (bottom: env(safe-area-inset-bottom)){
  body
  {
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
